import React from "react";
import {Badge, OverlayTrigger, Popover} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAnglesDown} from "@fortawesome/free-solid-svg-icons";
import "./LimitedBadges.scss";

interface ToolBadgesProps {
    tools: string[];
    labelClass: string;
}

export const LimitedBadges: React.FC<ToolBadgesProps> = ({tools, labelClass}) => {
    if (!tools || tools.length === 0 || tools[0] === "") return "-";

    const firstThree = tools.slice(0, 3);
    const remaining = tools.slice(3);

    return (
        <>
            {firstThree.map((tool, idx) => (
                <Badge key={idx} className={`${labelClass} me-1`}>
                    {tool}
                </Badge>
            ))}
            {remaining.length > 0 && (
                <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    overlay={
                        <Popover id="popover-tools">
                            <Popover.Body>
                                {remaining.map((tool, idx) => (
                                    <Badge key={idx} className={`${labelClass} me-1`}>
                                        {tool}
                                    </Badge>
                                ))}
                            </Popover.Body>
                        </Popover>
                    }
                    rootClose
                >
                    <FontAwesomeIcon icon={faAnglesDown} className="dropdown-icon ms-1" role="button"/>
                </OverlayTrigger>
            )}
        </>
    );
};

